import { combineReducers } from 'redux'
import offlineActivitiesModal from './reducers/offlineActivitiesModal'

export default combineReducers({
  offlineActivitiesModal,
})
